import { Model } from 'modules/core/lib/mobx-rest'

export interface ISchema {
  [key: string]: any
}

class Schema extends Model<ISchema> {
  static TOPIC_NAMES = {
    employees: 'employee',
    performance: 'performance', // ... add more as needed
  }

  static SCHEMA_NAMES = {
    trainings: 'Trainings',
    competencies: 'Competencies',
    growth_plans: 'Growth plans',
  }

  static urlRoot() {
    return '/custom_resources/schemas'
  }
}

export default Schema
